module.exports = __webpack_public_path__ + "img/de.29a39c27.svg";